import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import events from '../../events';
import { LocationType, HistoryType } from '../../types/router';
import { sendCommand } from '../../utils/mobile';

class AndroidBackHandler extends React.Component {
  constructor(props) {
    super(props);

    this.handler = () => this.handleBack();
  }

  componentWillMount() {
    events.on('messages.android-back', this.handler);
  }

  componentWillUnmount() {
    events.off('messages.android-back', this.handler);
  }

  handleBack() {
    const {
      selectedAffiliate,
      location: {
        pathname: path,
      },
      history,
    } = this.props;

    const urlParts = path.slice(1).split('/').slice(1);
    const firstPart = urlParts[0];
    const levels = urlParts.length;

    // Top page level back button handling
    switch (path) {
      case '/affiliates':
        if (selectedAffiliate) {
          return history.push('/access/settings');
        }

        // No affiliate selected - close the app.
        return sendCommand('close-app');
      case '/access/requests':
        return sendCommand('close-app');
      default:
        break;
    }

    // Sub level pages
    switch (levels) {
      case 1:
        // Default back navigation to the main first level page 'requests'
        return history.push('/access/requests');
      default:
        // Case with edit page will return to the details
        if (urlParts[2] === 'edit') {
          return history.push(`/access/${firstPart}/${urlParts[1]}/details`);
        }

        // Default back navigation to the first level page
        return history.push(`/access/${firstPart}`);
    }
  }

  render() {
    return null;
  }
}

AndroidBackHandler.propTypes = {
  location: LocationType,
  history: HistoryType,
  selectedAffiliate: PropTypes.bool,
};

const mapStateToProps = ({ session: { affiliateId } }) => ({
  selectedAffiliate: !!affiliateId,
});

export default withRouter(connect(mapStateToProps)(AndroidBackHandler));



// WEBPACK FOOTER //
// ./src/app/components/AndroidBackHandler.js